export default {
  addingTeamToWorkspace: 'Adding team to workspace',
  members: 'Members of the workspace',
  newWorkspaceMember: 'Adding new workspace member',
  noTeamHeadline: 'Workspace was created successfully!',
  noTeamTitle: 'No teams in the workspace yet.',
  noTeamCaption:
    'You can add one of the orphaned teams already created by clicking the button below or the plus sign above.',
  searchOrphanTeams: 'Search for orphaned teams',
  title: 'Workspace management',
  totalMembers: 'Total members',
  workspaceTeams: 'Teams in the workspace',
}
